import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/talker/types'
import * as data from '@/store/data/types'
import TalkerEntity, { ITalkerProps } from '@/entities/Talker'
import { IQueryProps } from '@/entities/Query'

export default class TalkerRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  get fetched(): ITalkerProps[] {
    return this.store.state.talker.fetched
  }

  set fetched(value: ITalkerProps[]) {
    this.store.commit(new types.Fetched(value))
    this.store.commit(new types.Store(value))
  }

  get entities(): TalkerEntity[] {
    return Object.values(this.store.state.talker.fetched).map((prop) => new TalkerEntity(prop))
  }

  get items() {
    return Object.values(this.store.state.talker.byIds)
  }

  get byIds() {
    return this.store.state.talker.byIds
  }

  set query(value: IQueryProps) {
    this.store.commit(new types.Query(value))
  }

  get query(): IQueryProps {
    return this.store.state.talker.query
  }

  set loading(value: boolean) {
    this.store.commit(new types.Loading(value))
  }

  get loading(): boolean {
    return this.store.state.talker.loading
  }

  set current(value: ITalkerProps) {
    this.store.commit(new types.Current(value))
  }

  get current(): ITalkerProps {
    return this.store.state.talker.current
  }

  set reset(value: boolean) {
    this.store.commit(new types.Reset(value))
  }

  get reset(): boolean {
    return this.store.state.talker.reset
  }

  /**
   * orderカラムを持っていてソート機能を使う場合はコメントアウトしてください
   */
  // get sortable(): TalkerEntity[] {
  //   return Object.values(this.store.state.talker.byIds)
  //     .sort((a, b) => {
  //       return a.order > b.order ? 1 : a.order < b.order ? -1 : 0
  //     })
  //     .map((prop: ITalkerProps) => new TalkerEntity(prop))
  // }

  // set sortable(value: TalkerEntity[]) {
  //   let i = 1
  //   const v = value.map((entity: any) => {
  //     return { ...entity.props, order: i++ }
  //   })
  //   this.store.commit(new types.Store(v))
  //   this.store.commit(new types.Fetched(v))
  // }

  update(value: ITalkerProps) {
    this.store.commit(new types.Update(value))
  }

  clear() {
    this.store.commit(new types.Clear())
  }

  response(value: { items: ITalkerProps[]; query: IQueryProps } | null | undefined) {
    if (value) {
      this.fetched = value.items
      this.query = value.query
      this.store.commit(new data.None(this.query.total === 0))
    }
  }
}
